/**
 * Service for cost center list operations
 */

import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import { buildQueryString } from '@/api/shared/queryBuilder';
import type { ApiResponse } from '@/api/shared/types';
import { mapCostCentersListFromTransport } from '../mappers';
import type {
  CostCentersListFilters,
  CostCentersListResult,
  LC_GetCostCentersListOut,
} from '../types';


export class CostCenterListService {
  async list(filters?: CostCentersListFilters): Promise<ApiResponse<CostCentersListResult>> {
    const queryString = buildQueryString(filters ?? {});
    const endpoint = `${API_CONFIG.ENDPOINTS.ORGANIZATION.COST_CENTERS}${queryString}`;

    const response = await apiClient.get<LC_GetCostCentersListOut>(endpoint);

    if (response.success && response.data) {
      return {
        ...response,
        data: mapCostCentersListFromTransport(response.data),
      };
    }

    return { ...response, data: null };
  }
}

export const costCenterList = new CostCenterListService();
